<template>
  <div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalDistribucionOC"
      role="dialog"
      tabindex="-1"
      data-controls-modal="your_div_id"
      data-backdrop="static"
      data-keyboard="false"
      href="#"
    >
      <div
        class="modal-dialog modal-lg"
        role="document"
        style="max-width: 100%"
      >
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 90%"
        >
          <button
            aria-label="Close"
            class="close"
            @click="CerrarModal()"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <h5 class="modal-title text-success">Distribución de orden compra</h5>
          <div
            class="onboarding-content with-gradient"
            style="
              padding: 15px 15px 1px 25px;
              overflow-y: scroll;
              max-height: 600px;
            "
          >
            <table v-if="dataTabla" class="table table-striped table-hover">
              <thead>
                <tr>
                  <th class="text-left">Producto</th>
                  <th>Cant. OC</th>
                  <th>UM</th>
                  <th
                    v-for="(tienda, key) in tiendas"
                    :value="tienda.codigo"
                    :key="key"
                    class="text-center"
                  >
                    <span>{{ tienda.nombre }}</span>
                  </th>
                  <th>Disponible</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detalle, indexDetalle) in dataTabla"
                  :key="indexDetalle"
                >
                  <td class="text-left" style="padding: 0rem">
                    <div class="value">{{ detalle.producto_obj.sku }}</div>
                    <span class="sub-value">
                      <small>{{ detalle.producto_obj.nombre }}</small>
                    </span>
                  </td>
                  <td style="padding: 0rem">
                    {{ detalle.cantidad_total }}
                  </td>
                  <td style="padding: 0rem">
                    {{ detalle.unidad_medida.nombre }}
                  </td>
                  <td
                    style="width: 85px; padding: 0rem"
                    v-for="(tienda, key) in tiendas"
                    :value="tienda.codigo"
                    :key="key"
                  >
                    <input
                      v-bind:style="
                        detalle.cantidad_um == 0
                          ? 'background-color: #FFF7E3;'
                          : 'background-color: white;'
                      "
                      @change="
                        calcularDistribucion(
                          $event,
                          indexDetalle,
                          tienda.codigo,
                          detalle
                        )
                      "
                      type="text"
                      value="0"
                      class="form-control form-control-sm"
                    />
                  </td>
                  <td style="padding: 0rem; width: 65px">
                    <input
                      v-bind:style="
                        detalle.cantidad_um == 0
                          ? 'background-color: #EDD28A; color: red; '
                          : 'background-color: #7DE3A8;'
                      "
                      type="text"
                      class="form-control form-control-sm font-weight-bold"
                      :disabled="true"
                      v-model="detalle.cantidad_um"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <!-------------------- END - Basic Table -------------------->
          </div>
          <div style="padding: 0px 10px 10px 10px" class="modal-footer">
            <button
              class="btn btn-success"
              @click="generarDistribucionOC(detalle_agregar)"
            >
              Generar la distribuición <i class="fa fa-paper-plane"></i>
            </button>
            <button class="btn btn-secondary" @click="CerrarModal()">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalNuevasOC"
      role="dialog"
      tabindex="-1"
      data-controls-modal="your_div_id"
      data-backdrop="static"
      data-keyboard="false"
      href="#"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            @click="CerrarModal()"
            type="button"
          >
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <h5 class="modal-title text-success">Nuevas OC generadas</h5>
          <div
            class="onboarding-content with-gradient"
            style="
              padding: 15px 15px 1px 25px;
              overflow-y: scroll;
              max-height: 600px;
            "
          >
            <table v-if="dataTabla" class="table table-striped table-hover">
              <thead>
                <tr>
                  <th># orden compra</th>
                  <th>Tienda</th>
                  <th>Referencia</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detalle, indexDetalle) in nuevaData"
                  :key="indexDetalle"
                >
                  <td>{{ detalle.numero }}</td>
                  <td>{{ detalle.tienda }}</td>
                  <td>{{ detalle.referencia }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-success"
                      @click="verNuevaOC(detalle.id)"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-------------------- END - Basic Table -------------------->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "../../../services/commons/DynamicService";
import notifications from "../../../notifications/notifications";

export default {
  props: ["dataTabla", "current"],
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      nuevaData: [],
      tiendas: [],
      index_: 0,
      ordenes_compras: {},
      detalle_agregar: [],
    };
  },

  computed: {},
  mounted() {
    let self = this;
    self.refreshTiendas();
  },
  methods: {
    verNuevaOC(id) {
      let self = this;
      let routeUrl = this.$router.resolve({
        name: "compras-ordencompra-editar",
        params: { id: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    calcularDistribucion(value, index, tienda, det) { 
      let self = this;
      let validate = det.id + tienda;
      let _cantidad = parseFloat(value.target.value);
      if (isNaN(_cantidad)) {
        Notifications.alert.error("No es un número valido");
        return;
      }
      if (_cantidad < 0) {
        Notifications.alert.error("Número no puede ser menor a 0");
      }
      if (self.dataTabla[index].cantidad_um < _cantidad) {
        Notifications.alert.error("Cantidad sobre pasa lo disponible");
        value.target.value = 0
        _cantidad = 0
      }
      let filter = self.detalle_agregar.filter(function (p) {
        return p.no_valid == validate;
      });

      if (filter[0]) {
        self.dataTabla[index].cantidad_um =
          self.dataTabla[index].cantidad_um + parseFloat(filter[0].cantidad);
        self.detalle_agregar = self.detalle_agregar.filter(function (p) {
          return p.no_valid !== validate;
        });
      }
      if (_cantidad > 0) {
        self.dataTabla[index].cantidad_um =
          self.dataTabla[index].cantidad_um - _cantidad;
        self.detalle_agregar[self.index_] = {
          tienda: tienda,
          cantidad: _cantidad,
          id: det.id,
          no_valid: det.id + tienda,
        };
      }
      self.index_ = self.detalle_agregar.length;
    },
    generarDistribucionOC(data) {
      let self = this;
      data.sort(function (a, b) {
        return b.tienda - a.tienda;
      });
      DynamicService.postAction(
        "compras",
        "orden_compra_e",
        self.current.id,
        "distribuir_oc_tiendas",
        data
      )
        .then((response) => {
          self.nuevaData = response.data;
          $("#modalDistribucionOC").modal("hide");
          Notifications.toast.success(
            "Distribuir orden de compra en tiendas",
            "Realizado Exitosamente"
          );
          $("#modalNuevasOC").modal("show");
          self.$emit("refreshCurrent");
          self.detalle_agregar = "";
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Distribuir orden de compra en tiendas",
            errors.response.data.detail
          );
        });
    },
    refreshTiendas() {
      let self = this;
      DynamicService.fetch("cat", "tiendas").then((response) => {
        self.tiendas = response.data.results;
      });
    },
    CerrarModal() {
      $("#modalDistribucionOC").modal("hide");
      $("#modalNuevasOC").modal("hide");
    },
  },
};
</script>
